import { API_URL } from "../constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (contactId) => `${API_URL}/api/v2/contacts/${contactId}/additional-properties`;

const createAdditionalProps = async (contactId) => await apiRequest(getUrl(contactId), "post");

export default createAdditionalProps;
